// extracted by mini-css-extract-plugin
export default {"primary":"styles_primary__QX6Op","secondary":"styles_secondary__Ydh2U","tertiary":"styles_tertiary__jbdIj"};